import React from "react";
import GovernanceLinkNav from "../components/GovernanceLinkNav";
import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import PdfPointer from "../components/PdfPointer";
import Footer from "../components/Footer";

const AssociationByLawsAndPolicies = () => {
  const pdfs = [
    {
      label: "اللائحة الاساسية للجمعية",
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/656eac3a4a329.pdf",
      size: '1,370 KB'
    },
    {
      label: "سياسة جمع التبرعات",
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/633b189603487.pdf",
      size: '1,384 KB'
    },
    {
      label: "سياسة تنظيم العلاقة مع المستفيدين",
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc79b0db75.pdf",
      size: '1,620 KB'
    },
    {
      label: "اللائحة التنظيمي للعمل التطوعي",
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc79b0db75.pdf",
      size: '1,620 KB'
    },
    {
      label: "سياسة تضارب المصالح",
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc821f0ba6.pdf",
      size: '2,843 KB'
    },
    {
      label: "سياسة الابلاغ عن المخالفات وحماية مقدمي البلاغات",
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc8406db84.pdf",
      size: '7,770 KB'
    },
    {
      label: "سياسة وخصوصية البيانات",
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc853364a4.pdf",
      size: '1,638 KB'
    },
    {
      label: "سياسة الاحتفاظ بالوثائق واتلافها",
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc862b8178.pdf",
      size: '1,071 KB'
    },
    {
      label: "الميثاق الأخلاقي للعاملين في القطاع غير الربحي",
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc8b71a083.pdf",
      size: '3,752 KB'
    },
    {
      label: `
سياسة التعامل مع الشركاء والمنفدين والاطراف الثالثة`,
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/623c4f771f379.pdf",
      size: '226 KB'
    },
    {
      label: `
سياسة الوقاية من عمليات غسل الاموال`,
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/633bcc9ed9eec.pdf",
      size: '1,473 KB'
    },
    {
      label: `سياسة الاشتباه بعمليات غسيل الأموال وجرائم الإرهاب`,
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/633bccce47244.pdf",
      size: '1,534 KB'
    },
    {
      label: `سياسة خصوصية المانحين والمتبرعين`,
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/623c4dbee4530.pdf",
      size: '225 KB'
    },
    {
      label: `سياسة الاستبدال والارجاع الخاصة بالتبرعات`,
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/66cdaa712645d.pdf",
      size: '364 KB'
    },
    {
      label: `
سياسة توجيه مبلغ للتبرع الى مشروع آخر`,
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/66cd9b9ea7e5b.pdf",
      size: '267 KB'
    },
    {
      label: `سياسة قواعد السلوك`,
      url: "https://www.saihatss.sa/rafed/uploads/website_regulations/623c4d6e461c6.pdf",
      size: '280 KB'
    },
  ];
  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <section className="pb-4 md:pb-10 pt-4 md:pt-10">
        <div className="max-w-screen-xl mx-auto px-3">
          <h1 className="text-primary font-bold text-center mt-4">
            اللوائح و السياسات
          </h1>
          <GovernanceLinkNav
            title={"الرئيسية"}
            module={"اللوائح و السياسات"}
          ></GovernanceLinkNav>
          <div className="mt-8">
            {pdfs.map((pdf, index) => (
              <PdfPointer key={index}
                data={pdf}
              ></PdfPointer>
            ))}
          </div>
        </div>
      </section>
      <Footer></Footer>
    </>
  );
};

export default AssociationByLawsAndPolicies;
